export const buildUIPAuthHeaders = (
  accessToken: string | null | undefined,
): Record<string, string> => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${String(accessToken || "")}`,
});
